import { render, staticRenderFns } from "./aws-ses.vue?vue&type=template&id=0db5e901&scoped=true&"
import script from "./aws-ses.vue?vue&type=script&lang=js&"
export * from "./aws-ses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5e901",
  null
  
)

export default component.exports